import * as i0 from '@angular/core';
import { InjectionToken, NgModule, Inject, Optional, SkipSelf } from '@angular/core';
import { setAnacapriElementsConfig } from '@anacapri/elements/dist/utilities';

const ANACAPRI_CONFIG_TOKEN = new InjectionToken('ANACAPRI_CONFIG_TOKEN');
/**
 * TODO: switch to a global provider once moving to Angular 15+
 */
class AnacapriModule {
    constructor(config, parentModule) {
        if (parentModule) {
            throw new Error('AnacapriModule is already loaded. Import it in the AppModule only');
        }
        if (config?.elementPrefix) {
            setAnacapriElementsConfig({ elementPrefix: config.elementPrefix });
        }
    }
    static forRoot(config) {
        return {
            ngModule: AnacapriModule,
            providers: [
                {
                    provide: ANACAPRI_CONFIG_TOKEN,
                    useValue: config,
                },
            ],
        };
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnacapriModule, deps: [{ token: ANACAPRI_CONFIG_TOKEN }, { token: AnacapriModule, optional: true, skipSelf: true }], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: AnacapriModule });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnacapriModule });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AnacapriModule, decorators: [{
            type: NgModule,
            args: [{}]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [ANACAPRI_CONFIG_TOKEN]
                }] }, { type: AnacapriModule, decorators: [{
                    type: Optional
                }, {
                    type: SkipSelf
                }] }]; } });

/**
 * Generated bundle index. Do not edit.
 */

export { ANACAPRI_CONFIG_TOKEN, AnacapriModule };
